<template>
    <div
      :style="{
      display: 'flex',
      justifyContent: 'center'}"
    >
      <p
        :style="{
        fontSize: '1.2rem',
        margin:'0' }"
      >
        {{ minutes }}:{{ seconds }}
      </p>
    </div>
  </template>

<script>
export default {
  props: {
    endDate: Date,
  },
  data() {
    return {
      days: null,
      hours: null,
      minutes: null,
      seconds: null,
    };
  },
  methods: {
    updateRemaining(distance) {
      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');
    },
    tick() {
      const currentTime = new Date();
      const distance = Math.max(this.endDate - currentTime, 0);
      this.updateRemaining(distance);

      if (distance === 0) {
        clearInterval(this.timer);
        this.$emit('sessionEnded', true);
      }
    },
  },
  mounted() {
    this.tick();
    this.timer = setInterval(this.tick.bind(this), 1000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>
